/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
